import { type Theme, readStoredTheme, subscribeTheme, toggleTheme } from '@/lib/theme';
import { useEffect, useState } from 'react';

// Bottom-of-NavRail light/dark toggle. Shows a sun glyph when on dark
// (action = switch to light), moon when on light (action = switch to dark).
// 44px square to match NavRail item height.
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => readStoredTheme());

  useEffect(() => subscribeTheme(setTheme), []);

  const next: Theme = theme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} theme`;

  return (
    <button
      type="button"
      onClick={() => setTheme(toggleTheme())}
      aria-label={label}
      title={label}
      className="shell-theme-toggle"
      style={{
        height: 44,
        width: 52,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--fg-2)',
        background: 'transparent',
        border: 'none',
        borderTop: '1px solid var(--bd)',
        cursor: 'pointer',
      }}
    >
      {theme === 'dark' ? <SunGlyph /> : <MoonGlyph />}
    </button>
  );
}

function SunGlyph() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="square"
      aria-hidden
    >
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3 3l1.4 1.4M11.6 11.6L13 13M3 13l1.4-1.4M11.6 4.4L13 3" />
    </svg>
  );
}

function MoonGlyph() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden
    >
      <path d="M13 9.5A5 5 0 1 1 6.5 3a4 4 0 0 0 6.5 6.5z" />
    </svg>
  );
}
